import qs from 'qs';
import {useMemo} from 'react';

type _QueryMapper = (param: string) => any;
type _QueryMapRules = Record<string, _QueryMapper>;
export type QueryMapRules = Record<string, _QueryMapper | _QueryMapRules>;


export const parseSearchParams = (p: URLSearchParams) => qs.parse(p.toString());

const createFieldMapper = (nullValues: any[], transformValue: (v: any) => any) => (fieldValue: any) => {
    if (nullValues.indexOf(fieldValue) === -1) {
        return transformValue(fieldValue);
    } else {
        return null;
    }
};

const mapNumberSelect = createFieldMapper([''], v => Number(v));
export const mapNumber = createFieldMapper([undefined, 'undefined', NaN, 'NaN'], v => Number(v));
export const mapNumberCheckbox = createFieldMapper([false, 'false', ''], v => Number(v));
export const mapBoolCheckbox = createFieldMapper([false, 'false'], v => ({
    true: true,
    false: false,
}[v as string]));

export const mapQSNullableBool = (v: string): any => {
    if (v === 'null' || v === '') {
        return null;
    }
    return {
        true: true,
        false: false,
    }[v];
};
export const mapQSEmptyNullableBool = (v: any): any => {
    if (v === false || v === 'false') {
        return null;
    } else {
        return mapQSNullableBool(v);
    }
};

export const mapQSNull = (v: string) => v || null;
export const mapQSNumber = (v: string) => !v ? Number(v) : null;
export const mapQSEmptyNumber = (v: any) => {
    if ([false, 'false', '0', 0, undefined, 'undefined'].indexOf(v as any) !== -1) {
        return null;
    } else {
        return mapQSNumber(v);
    }
};

const passValue = (v: any) => v;

export const mapParams: any = (mapping: QueryMapRules, params: any) =>
    Object
        .entries(params)
        .map(([k, v]) => {
            const mapper = mapping[k];
            if (mapper instanceof Function || !mapper) {
                return ({
                    // @ts-ignore
                    [k]: (mapper || passValue)(v as any)
                });
            } else if (mapper instanceof Object) {
                return {
                    [k]: mapParams(mapper, v),
                };
            } else {
                // eslint-disable-next-line no-console
                console.error(k, mapper);
                throw new Error('Неизвестный тип маппера');
            }
        })
        .reduce((res, v) => ({
            ...res,
            ...v
        }), {});

export const filterParams = (params: any) => Object
    .entries(params)
    .reduce((res, [k, v]) => {
        const result: any = {...res};

        if (v instanceof Object) {
            result[k] = filterParams(v);
            return result;
        }

        if ([null, undefined, ''].indexOf(v as any) === -1) {
            result[k] = v;
            return result;
        }

        return result;
    }, {});

export const useMapUrlParams = (mapQueryParams: QueryMapRules) => {
    return useMemo(() => (params: any) => filterParams(mapParams(mapQueryParams, params)), [mapQueryParams]);
};